import { render } from "./personalPage1.vue?vue&type=template&id=50acd574"
import script from "./personalPage1.vue?vue&type=script&lang=js"
export * from "./personalPage1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__